var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"clear center-text"},[_c('router-link',{staticClass:"btn btn-more",attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }